if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.variantIdInput.disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.submitButtonText = this.submitButton.querySelector('span');
      if (document.querySelector('cart-drawer')) {
        this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }
      this.hideErrors = this.dataset.hideErrors === 'true';
      this.quantityBreaks = document.getElementById(`quantity-breaks-${this.dataset.sectionId}`);
      this.customFields = document.querySelectorAll(`[id^='CustomField-${this.dataset.sectionId}-']`);
      this.variantInputs = this.form.querySelector('.product-form__variants');
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');

      if (this.querySelector('.loading__spinner')) {
        this.querySelector('.loading__spinner').classList.remove('hidden');
      }

      const complementaryProducts = this.getComplementaryProducts();
      const quantityBreakAddon = this.getQuantityBreakAddons();
      console.log('Complementary products found:', complementaryProducts.length);
      if (quantityBreakAddon) console.log('Quantity break addon found:', quantityBreakAddon);

      // 🔥 NUEVA ESTRATEGIA: No deshabilitar inputs, sino construir FormData selectivamente
      let hasQuantityBreaks = false;
      let variantCount = 0;
      let customFormData = new FormData();

      // Obtener el selling plan seleccionado (global para el producto)
      const selectedSellingPlan = document.querySelector('input[name="selling_plan"]:checked')?.value || '';

      if (this.quantityBreaks && this.quantityBreaks.formVariants?.length > 0) {
        hasQuantityBreaks = true;
        variantCount = this.quantityBreaks.formVariants.length;

        for (let i = 0; i < variantCount; i++) {
          const variant = this.quantityBreaks.formVariants[i];
          customFormData.append(`items[${i}][quantity]`, variant.quantity);
          customFormData.append(`items[${i}][id]`, variant.id);

          // Añadir el selling plan a cada variante solo si está seleccionado (y no es vacío)
          if (selectedSellingPlan) {
            customFormData.append(`items[${i}][selling_plan]`, selectedSellingPlan);
          }

          // Añadir custom fields si existen
          this.customFields.forEach(field => {
            customFormData.append(`items[${i}][properties][${field.fieldName}]`, field.fieldValue || field.fieldName);
          });
        }
      } else {
        // 🔥 MODO NORMAL: Usar FormData del form (variant picker funciona normal)
        variantCount = 1;
        customFormData = new FormData(this.form);
      }

      // Initialize running index for additional items
      let currentIndex = hasQuantityBreaks ? variantCount : 0;

      // 🔥 Añadir productos complementarios
      if (complementaryProducts.length > 0) {
        console.log('Adding complementary products to cart items');

        complementaryProducts.forEach((product, i) => {
          console.log(`Adding complementary ${i}: variant ${product.variantId} x${product.quantity} at index ${currentIndex}`);
          customFormData.append(`items[${currentIndex}][id]`, product.variantId);
          customFormData.append(`items[${currentIndex}][quantity]`, product.quantity);
          customFormData.append(`items[${currentIndex}][properties][_complementary]`, 'true');
          currentIndex++;
        });

        console.log(`Added ${complementaryProducts.length} complementary products`);
      }

      // 🔥 Añadir Quantity Break Addon
      if (quantityBreakAddon) {
        console.log(`Adding quantity break addon at index ${currentIndex}`);
        customFormData.append(`items[${currentIndex}][id]`, quantityBreakAddon.variantId);
        customFormData.append(`items[${currentIndex}][quantity]`, quantityBreakAddon.quantity);

        if (quantityBreakAddon.sellingPlan) {
          customFormData.append(`items[${currentIndex}][selling_plan]`, quantityBreakAddon.sellingPlan);
        }

        for (const [key, value] of Object.entries(quantityBreakAddon.properties)) {
          customFormData.append(`items[${currentIndex}][properties][${key}]`, value);
        }
        currentIndex++;
      }

      // 2) Añadir upsells manuales
      const sectionSelector = '[class*="upsell-section-"]';
      const checked = document.querySelectorAll(`${sectionSelector} .upsell-checkbox:checked`);
      const mainProductHandle = this.dataset.productHandle || window.location.pathname.split("/").pop()

      Array.from(checked).forEach((cb, i) => {
        customFormData.append(`items[${currentIndex}][id]`, cb.dataset.variantId);
        customFormData.append(`items[${currentIndex}][quantity]`, '1');
        customFormData.append(`items[${currentIndex}][properties][_upsell]`, 'true');
        customFormData.append(`items[${currentIndex}][properties][_linked_to_product]`, mainProductHandle);

        if (cb.dataset.downloadUrl) {
          customFormData.append(`items[${currentIndex}][properties][_download_url]`, cb.dataset.downloadUrl);
        }
        if (cb.dataset.sellingPlanId) {
          customFormData.append(`items[${currentIndex}][selling_plan]`, cb.dataset.sellingPlanId);
        }
        currentIndex++;
      });

      // 3) Añadir upsell automático
      if (window.autoUpsellConfig && window.autoUpsellConfig.enabled && window.autoUpsellConfig.variantId) {
        try {
          const response = await fetch('/cart.js', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
          });
          const cart = await response.json();
          const isInCart = cart.items.some(item => item.variant_id === window.autoUpsellConfig.variantId);

          if (!isInCart) {
            customFormData.append(`items[${currentIndex}][id]`, window.autoUpsellConfig.variantId);
            customFormData.append(`items[${currentIndex}][quantity]`, '1');
            customFormData.append(`items[${currentIndex}][properties][_upsell]`, 'true');
            // currentIndex++; 
          }
        } catch (e) {
          customFormData.append(`items[${currentIndex}][id]`, window.autoUpsellConfig.variantId);
          customFormData.append(`items[${currentIndex}][quantity]`, '1');
          customFormData.append(`items[${currentIndex}][properties][_upsell]`, 'true');
          // currentIndex++;
        }
      }

      // 4) Añadir secciones para cart drawer
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      if (this.cart) {
        customFormData.append('sections', this.cart.getSectionsToRender().map(s => s.id));
        customFormData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      config.body = customFormData;

      // 5) Enviar petición
      try {
        const response = await fetch(`${routes.cart_add_url}`, config);
        const json = await response.json();

        if (json.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            // 🔥 CORREGIDO: Obtener variant ID correctamente según el modo
            productVariantId: hasQuantityBreaks
              ? (this.quantityBreaks.formVariants[0]?.id || customFormData.get('items[0][id]'))
              : customFormData.get('id'),
            errors: json.errors || json.description,
            message: json.message,
          });

          this.handleErrorMessage(json.description);

          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (soldOutMessage) {
            this.submitButton.setAttribute('aria-disabled', 'true');
            this.submitButtonText.classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
          }

          this.error = true;
          return;
        }

        if (!this.cart) {
          window.location = window.routes.cart_url;
        } else if (this.form.querySelector('[type=submit]')?.dataset.skipCart === 'true') {
          window.location = '/checkout';
        } else {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            // 🔥 CORREGIDO: Obtener variant ID correctamente según el modo
            productVariantId: hasQuantityBreaks
              ? (this.quantityBreaks.formVariants[0]?.id || customFormData.get('items[0][id]'))
              : customFormData.get('id'),
            cartData: json,
          });

          this.error = false;

          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => this.cart.renderContents(json));
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(json);
          }
        }
      } catch (e) {
        this.error = true;
      } finally {
        this.submitButton.classList.remove('loading');

        if (this.cart?.classList.contains('is-empty')) {
          this.cart.classList.remove('is-empty');
        }

        if (!this.error) {
          this.submitButton.removeAttribute('aria-disabled');
        }

        this.querySelector('.loading__spinner')?.classList.add('hidden');

        // 🔥 NUEVO: Resetear complementary products
        this.resetComplementaryQuantities();
      }
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;

      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) this.errorMessage.textContent = errorMessage;
    }

    // 🔥 AÑADIDO: Método del código original de Shopify
    toggleSubmitButton(disable = true, text) {
      if (disable) {
        this.submitButton.setAttribute('disabled', 'disabled');
        if (text) this.submitButtonText.textContent = text;
      } else {
        this.submitButton.removeAttribute('disabled');
        this.submitButtonText.textContent = window.variantStrings.addToCart;
      }
    }

    // 🔥 NUEVO: Obtener addons de quantity breaks
    getQuantityBreakAddons() {
      if (!this.quantityBreaks) return null;

      const selectedOption = this.quantityBreaks.querySelector('input[name="quantity"]:checked');
      if (!selectedOption) return null;

      // The label is the next sibling of the input. The addon data is inside the label.
      const label = selectedOption.nextElementSibling;
      if (!label) return null;

      const addonData = label.querySelector('.addon-data');
      if (!addonData) return null;

      const variantId = addonData.dataset.addonVariant;
      const quantity = parseInt(addonData.dataset.addonQuantity);
      const isSubscription = addonData.dataset.addonSubscription === 'true';
      const sellingPlan = addonData.dataset.sellingPlan;

      if (!variantId || !quantity) return null;

      return {
        variantId,
        quantity,
        sellingPlan: isSubscription ? sellingPlan : null,
        properties: {
          '_addon_break': selectedOption.id,
          '_is_subscription_addon': isSubscription ? 'true' : null
        }
      };
    }


    // 🔥 NUEVO: Obtener productos complementarios
    getComplementaryProducts() {
      const products = [];
      const inputs = document.querySelectorAll('.complementary-quantity-input');

      console.log('Getting complementary products, found inputs:', inputs.length);

      inputs.forEach((input, index) => {
        const quantity = parseInt(input.value) || 0;
        const variantId = input.getAttribute('data-variant-id');
        const productId = input.getAttribute('data-product-id');
        const productTitle = input.getAttribute('data-product-title');

        console.log(`Complementary input ${index}:`, {
          quantity: quantity,
          variantId: variantId,
          productId: productId,
          productTitle: productTitle
        });

        if (quantity >= 1) {
          products.push({
            variantId: variantId,
            productId: productId,
            quantity: quantity,
            title: productTitle
          });

          console.log(`✓ Will add: ${productTitle} x${quantity} (variant: ${variantId})`);
        }
      });

      console.log('Final complementary products:', products);
      return products;
    }

    // 🔥 NUEVO: Resetear cantidades complementarias
    resetComplementaryQuantities() {
      const inputs = document.querySelectorAll('.complementary-quantity-input');
      inputs.forEach(input => {
        input.value = 0;
      });
      console.log('Complementary quantities reset to 0');
    }

    get variantIdInput() {
      return this.form.querySelector('[name=id]');
    }
  });

}